import { AnalysisDriverType } from "../types/types";
import { TableSegment } from "./segmentationTableUtils";
import { createHeaders } from "./excel/createHeaders";
import { buildRowData } from "./excel/buildRowData";
import { writeWorksheet } from "./excel/writeWorkSheet";
import { SegmentResponse } from "@/graphql/types/graphql";

export type MetricKey = "min" | "percentile25" | "percentile50" | "percentile75" | "max";

export const exportSegmentationDataToExcel = (
  displaySegments: TableSegment[],
  header1: string,
  header2: string,
  driver1Type: string | null,
  driver2Type: string | null,
  driver1Mode: AnalysisDriverType,
  driver2Mode: AnalysisDriverType,
  driver1NumeratorType: string | null,
  driver2NumeratorType: string | null,
  tableName: string,
  allSegments: TableSegment[],
  data: SegmentResponse[] | undefined,
  sortColumn: string = "range",
  sortDirection: "asc" | "desc" = "asc"
): void => {
  if (!displaySegments || displaySegments.length === 0) {
    return;
  }

  const segmentsToExport = allSegments;
  const hasOneDataAndOneManualSegment =
    segmentsToExport.length === 2 &&
    segmentsToExport.some((seg) => seg.method === "DATA") &&
    segmentsToExport.some((seg) => seg.method === "MANUAL");
  const isManualOnly = segmentsToExport.length === 1 && segmentsToExport.every((seg) => seg.method === "MANUAL");
  const isTwoSameMethod =
    segmentsToExport.length === 2 && segmentsToExport.every((seg) => seg.method === segmentsToExport[0].method);
  const segmentColumns =
    isManualOnly || hasOneDataAndOneManualSegment ? 2 : isTwoSameMethod ? 2 : segmentsToExport.length * 2;
  const totalColumn = segmentColumns;
  const header1Column = segmentColumns + 1;
  const header2Column = segmentColumns + 2;
  const driver1StartColumn = segmentColumns + 3;
  const driver2StartColumn = segmentColumns + 8;

  const headers = createHeaders(
    segmentsToExport,
    header1,
    header2,
    driver1Type,
    driver2Type,
    driver1Mode,
    driver2Mode,
    driver1NumeratorType,
    driver2NumeratorType,
    segmentColumns,
    totalColumn,
    header1Column,
    header2Column,
    driver1StartColumn,
    driver2StartColumn
  );

  const rowData = buildRowData(segmentsToExport, data, driver1Mode, driver2Mode, sortColumn, sortDirection);

  const worksheetData = [...headers, ...rowData.map((row) => row.map((value) => ({ v: value })))];

  writeWorksheet(worksheetData, segmentsToExport, segmentColumns, driver1StartColumn, driver2StartColumn, tableName);
};
